export default __webpack_public_path__ + "static/media/pp-w-6.eac40ee7.svg";